import { postMessageToIframeParent } from "./utills/iframeMessaging.ts";

const iframeResizer = () => {
	let prevHeight = 0;
	function sendHeight() {
		const iframe = document.getElementById("iframe-root");
		if (iframe) {
			const height = iframe.scrollHeight;
			if (prevHeight !== height) {
				prevHeight = height;
        postMessageToIframeParent({ height: height });
			}
		}
	}
	setInterval(sendHeight, 100);
};

const iframeEvents = () => {
	iframeResizer();
};

export default iframeEvents;
